import { useSelector } from "react-redux";
import { AppState } from "store";

function useCompanyLoadingState() {
  const currentCompanyId = useSelector((store: AppState) => store.auth.selectedCompany.id);
  const selectedCompanyId = useSelector((store: AppState) => store.auth.selectedCompanyId);

  return currentCompanyId !== selectedCompanyId;
}

export default useCompanyLoadingState;
